/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface DeckListings {
  readonly id: string;
  readonly first_name: string | null;
  readonly last_name: string | null;
  readonly email: string;
  readonly phone: string;
  readonly company_name: string;
  readonly company_description: string;
  readonly fundraising_goal: string;
  readonly attachment: string | null;
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
  readonly handled: boolean;
}
